import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ChatIcon, ChatIconOutline, DotDotDotVerticalIcon, MutedSpeakerIcon, UnmutedSpeakerIcon, } from '@streamr/tv-ui';
import { useRef } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { MediaService } from '../../services/media/MediaService';
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
import { UserService } from '../../services/user/UserService';
import { Anchor } from '../Anchor';
import { Button as LegacyButton } from '../Button';
import { ShareScreenButton } from '../broadcaster/helpers/ShareScreenButton';
import { AudioDeviceButton, VideoDeviceButton } from '../DeviceButton';
import { confirm } from '../popups/ConfirmationPopup';
import { selectCamera } from '../popups/devices/CameraSelectorPopup';
import { selectMicrophone } from '../popups/devices/MicrophoneSelectorPopup';
import { openViewerOptions } from '../popups/ViewerOptionsPopup';
export function GuestFooter({ onSidebarClick, showSidebar }) {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const mediaService = MediaService.getNotificationInterface();
    const mediaOutputAudioMuted = MediaService.getOutput().useAudioMuted();
    const mediaOutputVideoMuted = MediaService.getOutput().useVideoMuted();
    const connectedVideoDevices = MediaService.getOutput().useVideoDevices();
    const connectedAudioDevices = MediaService.getOutput().useAudioDevices();
    const optionsButtonAnchorRef = useRef(null);
    const playbackAudioMuted = !!StreamrAppService.getOutput().useAudioMuted();
    const onMuteAudioButtonClicked = () => {
        mediaService.notifyAudioMutingChangeRequested(!mediaOutputAudioMuted);
    };
    const onMuteVideoButtonClicked = () => {
        mediaService.notifyVideoMutingChangeRequested(!mediaOutputVideoMuted);
    };
    return (_jsxs(GuestFooterRoot, { children: [_jsxs(LeftSide, { children: [_jsx(LegacyButton, { type: "button", shape: "pill", padding: "none", kind: playbackAudioMuted ? undefined : 'secondary', variant: playbackAudioMuted ? undefined : 'dark', icon: playbackAudioMuted ? (_jsx(MutedSpeakerIcon, {})) : (_jsx(UnmutedSpeakerIcon, {})), onClick: () => {
                            StreamrAppService.getNotificationInterface().notifyToggleAudio();
                        } }), _jsx(AudioDeviceButton, { devicePresent: connectedAudioDevices.length > 0, muted: mediaOutputAudioMuted, onMuteClick: onMuteAudioButtonClicked, onSelectClick: (anchor) => {
                            selectMicrophone({
                                anchorRef: anchor,
                                variant: 'top-center',
                            });
                        } }), _jsx(VideoDeviceButton, { devicePresent: connectedVideoDevices.length > 0, muted: mediaOutputVideoMuted, onMuteClick: onMuteVideoButtonClicked, onSelectClick: (anchor) => {
                            selectCamera({
                                anchorRef: anchor,
                                variant: 'top-center',
                            });
                        } }), _jsx(ShareScreenButtonWrap, { children: _jsx(ShareScreenButton, {}) }), _jsx(LegacyButton, { type: "button", kind: "destructive", shape: "pill", onClick: async () => {
                            if (await confirm({
                                title: 'Leave stage',
                                message: 'Your camera and microphone will be turned off.',
                                okLabel: 'Leave',
                                cancelLabel: 'Cancel',
                            })) {
                                UserService.getNotificationInterface().notifyLeaveStage();
                            }
                        }, children: "Leave stage" })] }), _jsxs(RightSide, { children: [_jsx(ChatButton, { title: "Chat", onClick: () => onSidebarClick(), children: showSidebar ? _jsx(ChatIcon, {}) : _jsx(ChatIconOutline, {}) }), _jsx(Anchor, { ref: optionsButtonAnchorRef, children: _jsx(BaseButton, { title: "Settings", onClick: () => {
                                openViewerOptions({
                                    anchorRef: optionsButtonAnchorRef,
                                    activeBroadcast,
                                    variant: 'desktop',
                                });
                            }, children: _jsx(DotDotDotVerticalIcon, {}) }) })] })] }));
}
const ShareScreenButtonWrap = styled.div `
    display: var(--ShareScreenButton_Display, block);
`;
const LeftSide = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap-reverse;
    max-width: 60%;
    --ShareScreenButton_Display: none;

    @media (min-width: 48rem) {
        --ShareScreenButton_Display: initial;
    }
`;
const RightSide = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
`;
const GuestFooterRoot = styled.div `
    overflow: hidden;
    padding: 1.5rem;
    position: relative;

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    --DeviceButton_TopBackground: var(--tv-ui-color-4);
    --DeviceButton_UnderneathBackground: var(--tv-ui-color-21);
`;
const BaseButton = styled(Button) `
    --Button_Width: 3rem;
    --Button_Height: 3rem;
    color: var(--tv-ui-color-3);
`;
const ChatButton = styled(BaseButton) `
    display: none;
    @media (min-width: 60rem) {
        display: flex;
    }
`;
